import React from 'react';
import cx from 'clsx';
import { getSrc } from 'gatsby-plugin-image';
import Link from '../Link';
import Image from '../Image';
import infoQuery from '../../query/infoQuery';
import logoQuery from '../../query/logoQuery';
import productsQueryWithoutImage from '../../query/productsQueryWithoutImage';
import EmailIcon from '../Icons/Mail';
import MapPin from '../Icons/MapPin';
import Call from '../Icons/Call';
import {
    genCategoryUrl, aboutUrl, contactUrl, allNewsUrl, allAnnouncementUrl,
} from '../../utils/urls';
import { NotMobile } from '../MediaQuery';
import { googleMapAddressRouteWithProtocoal } from '../../utils/static';
import { sendEvent } from '../../utils/ga';
import * as moduleStyle from './index.module.scss';
import * as themeStyles from '../../assets/theme.module.scss';

const Footer = () => {
    const data = infoQuery();
    const normalizedProducts = productsQueryWithoutImage();
    const logo = logoQuery();

    return (
        <section className={themeStyles.bgDark}>
            <NotMobile>
                <div className={themeStyles.positionRelative}>
                    <div className={cx(themeStyles.shape, themeStyles.shapeBottom, themeStyles.shapeFluidX, themeStyles.textDark)}>
                        <svg viewBox="0 0 1440 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M0 24H1440V0C722.5 52 0 0 0 0V24Z" fill="currentColor" />
                        </svg>
                    </div>
                </div>
            </NotMobile>
            <footer className={cx(themeStyles.py10, themeStyles.pyMd11, themeStyles.bgDark, themeStyles.borderGray80050)}>
                <div className={themeStyles.container}>
                    <div className={themeStyles.row}>
                        <div className={cx(themeStyles.col6, themeStyles.colMd4)}>
                            <h4 className={cx(themeStyles.fontWeightBold, themeStyles.textUppercase, themeStyles.textWhite80)}>
                                產品
                            </h4>
                            <ul className={cx(themeStyles.listUnstyled, themeStyles.textMuted, themeStyles.mb6, themeStyles.mbMd8, themeStyles.mbLg0)}>
                                {Object.keys(normalizedProducts).map((key) => {
                                    const { name, url } = normalizedProducts[key];
                                    return (
                                        <li className={themeStyles.mb3} key={url}>
                                            <Link to={genCategoryUrl(url)} className={themeStyles.textReset}>
                                                {name}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>

                        </div>
                        <div className={cx(themeStyles.col6, themeStyles.colMd4)}>
                            <h4 className={cx(themeStyles.fontWeightBold, themeStyles.textUppercase, themeStyles.textWhite80)}>
                                公司資訊
                            </h4>
                            <ul className={cx(themeStyles.listUnstyled, themeStyles.textMuted, themeStyles.mb0)}>
                                <li className={themeStyles.mb3}>
                                    <Link to={aboutUrl} className={themeStyles.textReset}>
                                        關於建臺
                                    </Link>
                                </li>
                                <li className={themeStyles.mb3}>
                                    <Link to={contactUrl} className={themeStyles.textReset}>
                                        聯絡我們
                                    </Link>
                                </li>
                                <li className={themeStyles.mb3}>
                                    <Link to={allAnnouncementUrl} className={themeStyles.textReset}>
                                        公告
                                    </Link>
                                </li>
                                <li className={themeStyles.mb3}>
                                    <Link to={allNewsUrl} className={themeStyles.textReset}>
                                        資訊分享
                                    </Link>
                                </li>
                            </ul>

                        </div>
                        <div className={cx(themeStyles.col12, themeStyles.colMd4)}>
                            <Image
                                node={logo}
                                alt="建臺有限公司"
                                className={cx(themeStyles.footerBrand, themeStyles.imgFluid, themeStyles.mb2, moduleStyle.logo)}
                            />
                            <p className={cx('vcenter', themeStyles.textGray300, themeStyles.mb2)}>
                                <a
                                    className={cx('vcenter', moduleStyle.white)}
                                    href={googleMapAddressRouteWithProtocoal}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => sendEvent('Callout footer', 'click', 'address')}
                                >
                                    <MapPin className="svg-white" />
                                    {data.address}
                                </a>
                            </p>
                            <p className={cx('vcenter', themeStyles.textGray300, themeStyles.mb2)}>
                                <Call className={cx('svg-white', 'rotate-90')} />
                                <a
                                    className={cx(moduleStyle.phone, moduleStyle.white)}
                                    href={`tel:${data.phone1}`}
                                    onClick={() => sendEvent('Callout footer', 'click', 'phone1')}
                                >
                                    {data.phone1}
                                </a>
                                {' '}
                                /
                                {' '}
                                <a
                                    className={cx(moduleStyle.phone, moduleStyle.white)}
                                    href={`tel:${data.phone2}`}
                                    onClick={() => sendEvent('Callout footer', 'click', 'phone2')}
                                >
                                    {data.phone2}
                                </a>
                            </p>
                            <p className={cx('vcenter', themeStyles.textGray300, themeStyles.mb2)}>
                                <a
                                    className={moduleStyle.white}
                                    href={`mailto:${data.email}`}
                                    onClick={() => sendEvent('Callout footer', 'click', 'email')}
                                >
                                    <EmailIcon className="svg-white" />
                                    {data.email}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </section>
    );
};

export default Footer;
